import {
  AppClient,
  EventsClient,
  InventoryClient,
  OrphanClient,
  OSDClient,
  ProClient,
  ManifestsClient,
} from './fo.api.service';

const API_URL = window.config?.VITE_API_HOST;

export class OrphanService {
  public client: OrphanClient;

  constructor(token: string) {
    this.client = new OrphanClient(API_URL);
    this.client.setAuthToken(token);
  }

  public static getInstance(token: string): OrphanClient {
    return new OrphanService(token).client;
  }
}

export class ProService {
  public client: ProClient;

  constructor(token: string) {
    this.client = new ProClient(API_URL);
    this.client.setAuthToken(token);
  }

  public static getInstance(token: string): ProClient {
    return new ProService(token).client;
  }
}

export class ManifestService {
  public client: ManifestsClient;

  constructor(token: string) {
    this.client = new ManifestsClient(API_URL);
    this.client.setAuthToken(token);
  }

  public static getInstance(token: string): ManifestsClient {
    return new ManifestService(token).client;
  }
}

export class EventsService {
  public client: EventsClient;

  constructor(token: string) {
    this.client = new EventsClient(API_URL);
    this.client.setAuthToken(token);
  }

  public static getInstance(token: string): EventsClient {
    return new EventsService(token).client;
  }
}

export class InventoryService {
  public client: InventoryClient;

  constructor(token: string) {
    this.client = new InventoryClient(API_URL);
    this.client.setAuthToken(token);
  }

  public static getInstance(token: string): InventoryClient {
    return new InventoryService(token).client;
  }
}

export class AppService {
  public client: AppClient;

  constructor(token: string) {
    this.client = new AppClient(API_URL);
    this.client.setAuthToken(token);
  }

  public static getInstance(token: string): AppClient {
    return new AppService(token).client;
  }
}

export class OSDService {
  public client: OSDClient;

  constructor(token: string) {
    this.client = new OSDClient(API_URL);
    this.client.setAuthToken(token);
  }

  public static getInstance(token: string): OSDClient {
    return new OSDService(token).client;
  }
}

export default {
  AppService,
  EventsService,
  OrphanService,
  OSDService,
  ProService,
  ManifestService,
};
